// Source: app/scripts/services/customs-warehouse-form-helpers.js
/* global Auction */
Auction.factory('CustomsWarehouseFormHelpers', [function () {

  var entryDeclarationFields = [
    'entryIncompleteDeclaration',
    'entrySimplifiedDeclaration',
    'entryLocalClearance'
  ];

  var dischargeDeclarationFields = [
    'dischargeIncompleteDeclaration',
    'dischargeSimplifiedDeclaration',
    'dischargeLocalClearance'
  ];

  var transferInfoFields = [
    'transferWithoutFormalities',
    'transferToPremises',
    'transferForReExport'
  ];

  var warehouseTypeFields = [
    'warehouseTypeA',
    'warehouseTypeC',
    'warehouseTypeD'
  ];

  function resolveCustomsWarehouse(scope) {
    if (scope.customsWarehouseCaseEntity && scope.customsWarehouseCaseEntity.customsWarehouse) {
      return scope.customsWarehouseCaseEntity.customsWarehouse;
    }
    return scope.customsWarehouse || null;
  }

  function selectExclusiveOption(scope, fields, selectedField) {
    var warehouse = resolveCustomsWarehouse(scope);
    if (!warehouse || !warehouse[selectedField]) {
      return;
    }

    fields.forEach(function (field) {
      if (field !== selectedField) {
        warehouse[field] = false;
      }
    });
  }

  return {
    onEntryDeclarationOptionChange: function (scope, selectedField) {
      selectExclusiveOption(scope, entryDeclarationFields, selectedField);
    },
    onDischargeDeclarationOptionChange: function (scope, selectedField) {
      selectExclusiveOption(scope, dischargeDeclarationFields, selectedField);
    },
    onTransferInfoOptionChange: function (scope, selectedField) {
      selectExclusiveOption(scope, transferInfoFields, selectedField);
    },
    onWarehouseTypeOptionChange: function (scope, selectedField) {
      selectExclusiveOption(scope, warehouseTypeFields, selectedField);
    }
  };
}]);
